const COMPANIES = {
    listCompanies: "List of companies",
    newCompany: "new company",
    updateCompany: "Update Company",
    id: "ID",
    name: "Name",
    ExpiredTo: "Valid until",
    state: "State",
    accions: "Actions",

    "delete": "Delete",
    edit: "Edit",
    accept: "Accept",
    cancel: "Cancel",
    update: "Update",

    titleAlert: "Delete Company:",
    messageAlert: "This option cannot be undone, are you sure?",

    nit: "Nit",
    addressCompany: "Company address",
    contactEmail: "Contact email",
    nameCompany: "Company name",
    personContact: "Contact person",
    numberMovil: "Cell phone number",
    department: "Department",
    city: "City",
    contractDate: "contract date",
    expiredDate: "Expiration date",
    languages: "language (locale)",

    titleCard: "Hired services",
    module: "Module",
    yes: "Yes",
    multiForms: "Multiforms",
    subForms: "Subforms",
    moduleAnswer: "Response module",
    dataSource: "Data origin",
    notify: "Notifications",
    connectServi: "Connection to ServiForms",
    appServi: "App ServiForms",
    filterExportData: "Filter and data export",
    accessApi: "Access API ServiForms",
    showCase: "Showcase",
    Bots: "Bots",
    visits: "visits",
    Dispatcher: "Dispatcher",

    settingDispatcher: "Dispatcher Configuration",
    enterToken: "Enter API token",
    EnterUrl: "Enter API url",

    btnCreate: "Create",
    btnClean: "Clean up",

    selectedDate: "Select Date",

    companies: "Companies",
    errorQueryCompanies: "An error occurred when consulting the list of Companies",
    deleteCompany: "Delete companies",
    errorDeleteCompany: "An error occurred, when deleting the company",
    actionDisabled: "Action not available at the moment",
    company: "Company",

    successCompany: "The company has been created.",
    updateSuccess: "The company has been updated.",
    alertDateExpired: "The expiration date must be a minimum of one week."

}

export default { COMPANIES };